let onYouTubeIframeAPIReady;
let onPlayerStateChange;

const videoTypes = {};
const videoStories = {};
const youtubeVideos = {};
const pendingYouTubeAutoplay = {};

const isVideoBlockClick = (target) => {
	if (!target) {
		return null;
	}

	return target.closest('.video-block:not(.video-link):not(.marketing-list-access)');
};

const extractYouTubeId = (url) => {
	if (!url) {
		return null;
	}

	const directId = url.split('v=')[1];
	if (directId) {
		const ampersandPosition = directId.indexOf('&');
		return ampersandPosition !== -1 ? directId.substring(0, ampersandPosition) : directId;
	}

	const match = url.match(/^.*(?:youtu\.be\/|v\/|embed\/|watch\?|youtube\.com\/user\/[^#]*#(?:[^\/]*?\/)*)\??v?=?([^#&?]*).*/);
	return match ? match[1] : null;
};

const handleVideoBlockClick = (event) => {
	const videoBlock = isVideoBlockClick(event.target);

	if (!videoBlock) {
		return;
	}

	event.preventDefault();

	const iframeSrc = videoBlock.dataset.iframeSrc;

	if (!iframeSrc) {
		return;
	}

	const info = videoBlock.querySelector('.video-info');
	const display = videoBlock.querySelector('.video-display');

	if (info) {
		info.classList.add('hidden');
	}

	if (display) {
		display.classList.remove('hidden');
	}

	const story = videoStories[iframeSrc];
	const type = videoTypes[iframeSrc];

	if (!story || !type) {
		if (!story && type === 'youtube') {
			pendingYouTubeAutoplay[iframeSrc] = true;
		}
		return;
	}

	if (type === 'vimeo' && typeof story.play === 'function') {
		story.play();
		if (typeof story.setVolume === 'function') {
			story.setVolume(1);
		}
		return;
	}

	if (type === 'youtube') {
		if (typeof story.loadModule === 'function') {
			story.loadModule('captions');
			story.loadModule('cc');
		}
		if (typeof story.setVolume === 'function') {
			story.setVolume(100);
		}
		if (typeof story.playVideo === 'function') {
			story.playVideo();
			pendingYouTubeAutoplay[iframeSrc] = false;
		}
	}
};

const loadVideos = () => {
	const videoBlocks = document.querySelectorAll('.video-block');

	videoBlocks.forEach((block) => {
		const iframeSrc = block.dataset.iframeSrc;

		if (!iframeSrc) {
			return;
		}

		let type = null;

		if (block.classList.contains('youtube')) {
			type = 'youtube';
		} else if (block.classList.contains('vimeo')) {
			type = 'vimeo';
		}

		if (!type) {
			return;
		}

		videoTypes[iframeSrc] = type;

		if (type === 'vimeo' && typeof Vimeo !== 'undefined' && Vimeo.Player) {
			const frame = block.querySelector('.video-frame');
			if (!frame) {
				return;
			}
			const story = new Vimeo.Player(frame, { url: iframeSrc });
			if (typeof story.setVolume === 'function') {
				story.setVolume(0);
			}
			videoStories[iframeSrc] = story;
			return;
		}

	if (type === 'youtube') {
		const element = block.querySelector('.video-iframe');
		const videoId = extractYouTubeId(iframeSrc);

			if (!element || !videoId) {
				return;
			}

		youtubeVideos[videoId] = {
			videoElement: element,
			iframeSrc,
		};
	}
	});

	onYouTubeIframeAPIReady = () => {
		Object.keys(youtubeVideos).forEach((videoId) => {
			const { videoElement, iframeSrc } = youtubeVideos[videoId];

			if (!videoElement) {
				return;
			}

			const story = new YT.Player(videoElement, {
				videoId,
				playerVars: {
					cc_load_policy: 1,
					autoplay: 0,
					playsinline: 1,
				},
				events: {
					onReady: (event) => {
						if (pendingYouTubeAutoplay[iframeSrc]) {
							if (typeof event.target.loadModule === 'function') {
								event.target.loadModule('captions');
								event.target.loadModule('cc');
							}
							if (typeof event.target.setVolume === 'function') {
								event.target.setVolume(100);
							}
							if (typeof event.target.playVideo === 'function') {
								event.target.playVideo();
							}
							pendingYouTubeAutoplay[iframeSrc] = false;
						}
					},
					onStateChange: onPlayerStateChange,
				},
			});

			videoStories[iframeSrc] = story;
		});
	};
};

if (document.querySelector('.video-block')) {
	document.addEventListener('click', handleVideoBlockClick, false);
	window.videoStories = videoStories;
	window.loadVideos = loadVideos;
	window.onYouTubeIframeAPIReady = () => onYouTubeIframeAPIReady && onYouTubeIframeAPIReady();

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', loadVideos);
	} else {
		loadVideos();
	}
}
